import {getUserLocale} from '@utils/user';

export const formatDateString = (
    value: string,
    options: Intl.DateTimeFormatOptions = {
        year: 'numeric', // e.g., "2024"
        month: 'long', // e.g., "June"
        day: 'numeric', // e.g., "1"
    }
): string => {
    const date = new Date(value);
    if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
    }

    // Fix the locale string if necessary
    const rawLocale = getUserLocale();
    const locale = rawLocale.replace('_', '-'); // e.g., "zh_CN" → "zh-CN"
    const includesTime =
        options.timeStyle !== undefined ||
        options.hour !== undefined ||
        options.minute !== undefined ||
        options.second !== undefined;

    return includesTime
        ? date.toLocaleString(locale, options)
        : date.toLocaleDateString(locale, options);
};
